const standard = () =>
`
  <Badge color={BADGE_STATUS_COLOR['ready']}>ready</Badge>
`;

const badgesTemplates = {
  standard: standard()
};

export default badgesTemplates;


// WEBPACK FOOTER //
// ./src/containers/elements/Badges/constants/badgesTemplates.js